import { createSelector } from 'reselect';
import { List } from 'immutable';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import { getInterval, formatDuration } from '../../util';
import { TESTS_REQUEST_SIZE } from '../../constants';

const routerLocation = (store) => store.router.location;
const filters = (store) => store.apps.analytics.filters;
const trendsStore = (store) => store.apps.analytics.trends;
const generalStore = (store) => store.apps.analytics.generalReducer;

export const trendsSelector = createSelector([
  filters,
  routerLocation,
  trendsStore,
  generalStore,
], (filteredFilters, location, trends, general) => ({
  filters: filteredFilters.get('filters'),
  selectedDateFilter: filteredFilters.get('selectedDateFilter'),
  location,
  loading: general.get('loading'),
  loadingTests: trends.tests.get('loading'),
  testsCountData: trends.tests.get('testsCountData'),
  statusCountData: trends.tests.get('statusCountData'),
  totalTests: trends.tests.get('totalTests'),
  passedRate: trends.tests.get('passedRate'),
  loadingErrors: trends.errors.get('loading'),
  errorsCountData: trends.errors.get('errorsCountData'),
  totalErrors: trends.errors.get('totalErrors'),
  selectedDays: formatDuration(filteredFilters.get('selectedDateFilter')),
  loadingBuilds: trends.builds.get('loading'),
  selectedStatus: trends.builds.get('selectedStatus'),
  builds: trends.builds.get('builds'),
  testsByBuild: trends.builds.get('testsByBuild'),
  testsWithoutBuild: trends.builds.get('testsWithoutBuild'),
  hasMoreTests: trends.builds.get('hasMoreTests'),
  totalTestsWithoutBuild: trends.builds.get('totalTests'),
  currentPage: trends.builds.get('currentPage'),
}));

export const trendsTestsParamsSelector = createSelector([
  filters,
  (store, options = {}) => options,
], (filtersStore, options) => {
  const timeParam = getTimeFilterParams(filtersStore.get('selectedDateFilter'), options.base);

  return {
    ...getFilterParamsAdapter(filtersStore.get('filters')),
    ...timeParam,
    interval: getInterval(timeParam.end - timeParam.start),
  };
});

export const buildsRequestParamsSelector = createSelector([
  trendsTestsParamsSelector,
  trendsStore,
], (filtersSelector, trends) => {
  const status = trends.builds.get('selectedStatus');

  return {
    ...filtersSelector,
    ...(status ? { status } : {}),
  };
});

export const testsParamsSelector = createSelector([
  buildsRequestParamsSelector,
  trendsStore,
  (store, options = {}) => options,
], (buildParams, trends, options) => {
  const page = options.newPage || trends.builds.get('currentPage');
  const buildInfo = options.build ? { build: options.build } : { missing_build: true };

  return {
    ...buildParams,
    ...buildInfo,
    from: (page * TESTS_REQUEST_SIZE) - TESTS_REQUEST_SIZE,
    size: TESTS_REQUEST_SIZE,
  };
});

export const getTestsFromBuild = createSelector([
  trendsStore,
  (store, options = {}) => options,
], (trends, options) => {
  const selectedBuild = trends.builds.get('builds').find(({ name }) => name === options.build);
  return selectedBuild ? selectedBuild.tests : List([]);
});

export default trendsSelector;
